// Dependencies
import React, { Component } from 'react';

import classnames from 'classnames';
// eslint-disable-next-line lodash/import-scope
import { get } from 'lodash';
import PropTypes from 'prop-types';

import {
  Impression,
  ImpressionContext,
} from '@nerdwallet/analytics/react/impression';

// Utils

import { cdnUri } from '@nerdwallet/nw-client-lib/cdn';

const imgUri = cdnUri('img/diy/hac', 'png');

const isRegistration = (identity) => {
  // HACK: to check if a user is registering or signing in
  // Look at the account created at timestamp and see if it within last 5 mins
  const createdAt = new Date(get(identity, 'current.created_at'));
  const timestampNow = new Date();

  return timestampNow - createdAt <= 300000;
};

class AuthModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAuthenticated: false,
      isRegistration: false,
    };

    this.ref = React.createRef();

    this.onAuthSuccess = this.onAuthSuccess.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onStateChange = this.onStateChange.bind(this);
  }

  onAuthSuccess(identity) {
    // onAuthSuccess only gets triggered when the user has completed ALL the steps in the flow
    this.props.onSignIn(identity);
  }

  onStateChange({ identity }) {
    // onStateChange gets triggered every time theres a changes in auth dialog redux state
    // ie every step in the flow will trigger 1 or more onStateChange
    if (!this.state.isAuthenticated && get(identity, 'isSignedIn', false)) {
      this.setState({
        isAuthenticated: true,
      });

      this.props.onSignIn(identity);

      if (!this.state.isRegistration && isRegistration(identity)) {
        this.setState({
          isRegistration: true,
        });

        this.props.onRegistration(identity);
      }
    }
  }

  onClick(e, impressionId) {
    if (typeof window !== 'undefined') {
      e.preventDefault();
      e.stopPropagation();
    }

    this.props.onClick();

    this.showAuthDialog(impressionId);
  }

  showAuthDialog(impressionId) {
    if (typeof window !== 'undefined') {
      const { flow, flowConfig, tracking } = this.props;

      window.nwapi.ui.showAuthDialog({
        version: 2,
        onSuccess: this.onAuthSuccess,
        onStateChange: this.onStateChange,
        flowConfig,
        flow,
        trk: {
          trk_mode: 'modal',
          trk_channel: 'web',
          trk_element: 'ad_unit',
          trk_copy: tracking,
          trk_location: tracking,
          navigation_source_impression_id: impressionId,
        },
      });
    }
  }

  render() {
    const { impressionPayload, className } = this.props;

    return (
      <Impression {...impressionPayload}>
        <ImpressionContext.Consumer>
          {({ impressionId }) => {
            return (
              <div
                ref={this.ref}
                onClick={(e) => {
                  this.onClick(e, impressionId);
                }}
                className={classnames('auth-modal', className)}
              >
                {this.props.children}
              </div>
            );
          }}
        </ImpressionContext.Consumer>
      </Impression>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
AuthModal.displayName = 'AuthModal';

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
AuthModal.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  flow: PropTypes.string,
  version: PropTypes.number,
  flowConfig: PropTypes.object,
  onClick: PropTypes.func,
  onSignIn: PropTypes.func,
  onRegistration: PropTypes.func,
  tracking: PropTypes.string,
  ctaFormat: PropTypes.string,
  entityName: PropTypes.string,
  impressionPayload: PropTypes.object,
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
AuthModal.defaultProps = {
  flow: 'credit-score',
  version: 1,
  flowConfig: {
    slides: [
      {
        copy: 'Get your score, see your rate.',
        image: imgUri('house-slider-bg-score'),
      },
      true,
      true,
    ],
  },
  onSignIn: () => {},
  onRegistration: () => {},
  onClick: () => {},
  tracking: null,
  ctaFormat: 'button',
  entityName: 'auth_modal',
  className: '',
  impressionPayload: {},
};

export default AuthModal;
